import { formatMoney } from "../../toll/money";
import { observer } from "mobx-react-lite";
import userStore from "../../stores/userStore";
import moment from "moment";
import PageBox from "../../layout/PageBox";
import { Button } from "antd";
import { MdKeyboardArrowDown } from "react-icons/md";
import { MyColor } from "../../config/myStyle";
import { member_icon } from "../../imgs";
import { campaignStore } from "../../stores";
import MyRecordCampaignItem from "./MyRecordCampaignItem";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { GetCampaignRes } from "../../api";
import { useTranslation } from "react-i18next";

type SelectType = 'all' | 'ongoing' | 'completed' | 'expired'

const MyRecordTotalRaised = observer(() => {
  const { t } = useTranslation();
  const navigate = useNavigate()
  const userData = userStore.userData
  const [selectType, setSelectType] = useState<SelectType>('ongoing')
  const [campaignData, setCampaignData] = useState<{ type: SelectType, title: string, data: GetCampaignRes[] }[]>([])

  useEffect(() => { userStore.getUser(); }, []);
  useEffect(() => {
    if (!userStore.userData?.id) return;
    campaignStore.getCampaignList({ limit: 3000, userId: userStore.userData?.id })
  }, [userStore.userData?.id])

  useEffect(() => {
    const allData: GetCampaignRes[] = []
    const completedData: GetCampaignRes[] = []
    const expiredData: GetCampaignRes[] = []
    const ongoingData: GetCampaignRes[] = []
    campaignStore.campaignList.forEach((item, index) => {
      switch (item.status) {
        case 'ongoing': {
          ongoingData.push(item)
          allData.push(item)
        }
          break
        case 'completed': {
          completedData.push(item)
          allData.push(item)
        }
          break
        case 'expired': {
          expiredData.push(item)
          allData.push(item)
        }
          break
      }
    })
    setCampaignData([
      { title: t('my_record_total_raised.all'), type: 'all', data: allData },
      { title: t('my_record_total_raised.current'), type: 'ongoing', data: ongoingData },
      { title: t('my_record_total_raised.completed'), type: 'completed', data: completedData },
      { title: t('my_record_total_raised.expired'), type: 'expired', data: expiredData },
    ])
  // eslint-disable-next-line
  }, [campaignStore.campaignList, t])

  return (
    <PageBox spinning={campaignStore.campaignListStatus.loading}>
      <div>
        <div className="flex flex-col items-coneter px-[25px]" style={{ color: MyColor.blue, fontWeight: 500, fontSize: 16 }}>
          {/* 用户信息 */}
          <div className="flex items-center bg-[white] px-[20px] mt-[15px] pt-[10px]" style={{ borderTopLeftRadius: 10, borderTopRightRadius: 10, borderBottomWidth: 5, borderColor: MyColor.sub }}>
            <img className="h-[54px]" src={member_icon} />
            <div className="ml-[25px]">
              <div
                style={{
                  overflow: "hidden",
                  display: "-webkit-box",
                  WebkitLineClamp: 1,
                  WebkitBoxOrient: "vertical"
                }}
              >
                {[userData?.englishGivenName, userData?.englishSurname].filter(Boolean).join(' ')}
              </div>
              <div
                style={{
                  overflow: "hidden",
                  display: "-webkit-box",
                  WebkitLineClamp: 1,
                  WebkitBoxOrient: "vertical"
                }}
              >
                {t("my_record_total_raised.account_no")}{userData?.memberNumber??userData?.id}
              </div>
            </div>
          </div>
          {/* select type */}
          <div className="flex items-center space-x-[5px] mt-[20px]">
            {campaignData.map((item, index) => {
              return (
                <div
                  onClick={() => setSelectType(item.type as SelectType)}
                  className="text-[11px] h-[30px] flex items-center px-[8px]"
                  style={{
                    borderRadius: 15,
                    borderWidth: 2,
                    borderColor: MyColor.sub,
                    color: item.type === selectType ? 'white' : MyColor.sub,
                    backgroundColor: item.type === selectType ? MyColor.sub : 'white',
                  }}
                  key={item.type}
                >
                  {item.title}<div className="text-[9px]">{`(${item.data.length})`}</div>
                </div>
              )
            })}
          </div>

          {/* total raised */}
          <div className="flex flex-col items-center justify-center font-[700] text-[20px] mt-[10px] mb-[10px]" style={{ color: MyColor.blue, lineHeight: 1.4 }}>
            <div>{t('my_record_total_raised.total_raised')}</div>
            <div className="text-[14px]">{t('my_record_total_raised.hkd')}</div>
            <div className="text-[34px]" style={{ lineHeight: 1.2 }}>{formatMoney(userData?.receivedDonationAmount)}</div>
            {userData?.receivedDonationAt && (
              <div className="text-[14px] font-[400]">
                {t('my_record_total_raised.balance_as_at')} {moment(userData?.receivedDonationAt).format("D MMM, YYYY")}
              </div>
            )}
          </div>
          <div className="h-[2px] bg-[rgba(0,0,0,0.4)] " />

          {/* campaign items */}
          <div className="flex-col flex space-y-[10px] mt-[10px]">
            {campaignData.find(item => item.type === selectType)?.data.map((item, index) => {
              return (
                <MyRecordCampaignItem
                  key={item.id}
                  campaign={item}
                />
              )
            })}
          </div>
        </div>
      </div>
    </PageBox>
  );
})

export default MyRecordTotalRaised;
